import React from "react";

export default function DiagnozeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-9 w-9"
      viewBox="0 0 41 42"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.7917 7.4427C12.1873 7.4427 6.83342 12.7966 6.83342 19.401C6.83342 26.0054 12.1873 31.3594 18.7917 31.3594C25.3962 31.3594 30.7501 26.0054 30.7501 19.401C30.7501 12.7966 25.3962 7.4427 18.7917 7.4427ZM3.41675 19.401C3.41675 10.9097 10.3004 4.02603 18.7917 4.02603C27.2831 4.02603 34.1668 10.9097 34.1668 19.401C34.1668 27.8924 27.2831 34.776 18.7917 34.776C10.3004 34.776 3.41675 27.8924 3.41675 19.401Z"
        fill="white"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.8339 28.443C28.501 27.7759 29.5827 27.7759 30.2498 28.443L37.0831 35.2764C37.7503 35.9435 37.7503 37.0252 37.0831 37.6923C36.416 38.3595 35.3343 38.3595 34.6672 37.6923L27.8339 30.859C27.1667 30.1918 27.1667 29.1102 27.8339 28.443Z"
        fill="white"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
